import api from './api';
import { PriceSlab, PriceSlabFormData, PriceSlabsResponse } from '../types/priceSlab';

export interface PriceSlabFilters {
  page?: number;
  limit?: number;
  search?: string;
  boreSizeId?: number;
  status?: 'active' | 'cancelled' | 'all';
}

class PriceSlabService {
  async getPriceSlabs(filters: PriceSlabFilters = {}): Promise<PriceSlabsResponse> {
    const params = new URLSearchParams();
    
    Object.entries(filters).forEach(([key, value]) => {
      if (value !== undefined && value !== '') {
        params.append(key, String(value));
      }
    });

    const response = await api.get(`/price-slabs?${params}`);
    return response.data;
  }

  async getPriceSlab(id: number): Promise<PriceSlab> {
    const response = await api.get(`/price-slabs/${id}`);
    return response.data;
  }

  async createPriceSlab(data: PriceSlabFormData): Promise<PriceSlab> {
    const response = await api.post('/price-slabs', data);
    return response.data.priceSlab;
  }

  async updatePriceSlab(id: number, data: PriceSlabFormData): Promise<PriceSlab> {
    const response = await api.put(`/price-slabs/${id}`, data);
    return response.data.priceSlab;
  }

  async deletePriceSlab(id: number): Promise<void> {
    await api.delete(`/price-slabs/${id}`);
  }

  async getPriceSlabsByBoreSize(boreSizeId: number): Promise<PriceSlab[]> {
    const response = await api.get(`/price-slabs/bore-size/${boreSizeId}`);
    return response.data.priceSlabs;
  }

  async bulkUpdatePriceSlabs(boreSizeId: number, slabs: any[]): Promise<any> {
    const response = await api.put(`/price-slabs/bore-size/${boreSizeId}/bulk`, { slabs });
    return response.data;
  }
}

const priceSlabService = new PriceSlabService();
export default priceSlabService;